import React from 'react'

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center gap-4 py-16 text-center text-k-ink">
                    <p className="m-0 text-xl font-extrabold">Algo salió mal</p>
                    <p className="m-0 max-w-md text-sm text-k-muted">Recarga la pantalla. Si el problema continúa, contacta a soporte.</p>
                    <button type="button" className="k-btn-filled" onClick={() => window.location.reload()}>
                        Recargar
                    </button>
                </div>
            )
        }
        return this.props.children
    }
}
